const projectsdata = [
    {
        title: "CAR Management System",
        image: "./cms.svg",
        description: "this is an andriod app used to sell or buy cars",
        link: '/',
    },
    {
        title: "Chat App",
        image: "./chatapp.svg",
        description: "App through which u can chat with other by creating a room",
        link: '/',
    },
    {
        title: "Box office",
        image: "./boxoffice.svg",
        description: "App developed in react uses the api to search for movies",
        link: '/',
    },
    {
        title: "E-Commerse website",
        image: "./ecommerse.svg",
        description: "this is an online e commerse app like flipkart",
        link: '/',
    },
    {
        title: "Pencore",
        image: "./pencore.svg",
        description: "an program developed in python using wamp as DB and some libraries to visualize  data",
        link: '/',
    },
];

export default projectsdata;